import z from 'zod'

/**
 * O POST de criacao devolve o id do registro recem-criado, mas o envelope
 * varia entre os endpoints do registry. Aceitamos as formas conhecidas em vez
 * de fixar uma: o id e o que permite desfazer o cadastro se o usuario cancelar
 * a etapa de validacao.
 */
export const CreatedGeoImageIdSchema = z.union([
	z.uuid(),
	z.object({ id: z.uuid() }).transform((data) => data.id),
	z.object({ result: z.uuid() }).transform((data) => data.result),
	z.object({ result: z.object({ id: z.uuid() }) }).transform((data) => data.result.id),
])
